<template>
  <section class="relative min-h-screen flex flex-col items-center justify-start py-24 px-4 sm:px-8 xl:px-12 bg-black overflow-hidden">
    <!-- Grainient Animated Background -->
    <div class="absolute inset-0 z-0 opacity-100">
      <Grainient
        color1="#1151c0"
        color2="#1f9eff"
        color3="#bffe78"
        :time-speed="0.75"
        :color-balance="0.0"
        :warp-strength="1.0"
        :warp-frequency="5.0"
        :warp-speed="3.0"
        :warp-amplitude="50.0"
        :blend-angle="0.0"
        :blend-softness="0.05"
        :rotation-amount="500.0"
        :noise-scale="2.0"
        :grain-amount="0.1"
        :grain-scale="2.0"
        :grain-animated="false"
        :contrast="1.5"
        :gamma="1.0"
        :saturation="1.0"
        :center-x="0.0"
        :center-y="0.0"
        :zoom="0.9"
      />
    </div>

    <!-- Hero Text Content (Centered at top) -->
    <div class="relative z-20 w-full max-w-4xl mx-auto flex flex-col items-center text-center space-y-12 mb-16 animate-in fade-in slide-in-from-top-8 duration-1000">
      <div class="space-y-6">
        <div class="inline-flex text-white items-center gap-2 mb-2 justify-center">
          <img :src="pinIcon" alt="Pin Icon" class="h-5 w-5 invert" />
          Your Next Role is Here
        </div>

        <h1 class="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-medium tracking-tight text-white leading-[1.05]">
          Track your applications.<br />
          Get the offer.
        </h1>
      </div>
      
      <div class="flex flex-wrap items-center justify-center gap-4">
        <span class="bg-[#ccff00] text-[#1a66e6] px-6 py-3 rounded-full text-base font-semibold shadow-sm">
          Community Sourced
        </span>
        <span class="bg-[#ccff00] text-[#1a66e6] px-6 py-3 rounded-full text-base font-semibold shadow-sm">
          Automatic Matching
        </span>
        <span class="bg-[#ccff00] text-[#1a66e6] px-6 py-3 rounded-full text-base font-semibold shadow-sm">
          Direct Referrals
        </span>
      </div>

      <div class="text-white text-lg">
        Outtalent's job platform for tracking your applications, finding relevant roles, getting matched with the right employers, and receiving direct referrals from our community of fellows.
      </div>
      <div class="pt-4">
        <router-link to="/register">
          <Button class="bg-white text-[#1a66e6] hover:bg-gray-50 rounded-full px-12 py-8 text-base font-semibold shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 active:scale-95 duration-200">
            Register for Free
          </Button>
        </router-link>
      </div>
    </div>

    <!-- Dashboard Preview (Centered below) -->
    <DashboardPreview />
  </section>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import DashboardPreview from './DashboardPreview.vue'
import Grainient from './Grainient.vue'
import pinIcon from '@/assets/pin-icon.svg'
</script>

<style scoped>
.perspective-1000 {
  perspective: 1000px;
}
</style>
